import React from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="30209" id="get-started" ref={ref} className="relative w-full overflow-hidden py-24 md:py-32 dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-linear-to-br from-background via-secondary/10 to-background z-0" />

      {}
      <div className="absolute inset-0 opacity-5 z-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1453987/img/circuit_board_pattern.png)] bg-repeat bg-center mix-blend-overlay" style={{
      backgroundSize: "400px"
    }} />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[600px] rounded-full bg-secondary/5 blur-[120px] z-0 pointer-events-none" />

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center">
        
        {}
        <h1 className={cn("text-primary font-serif font-semibold text-4xl md:text-[64px] leading-[1.1] tracking-tight max-w-4xl mb-10 drop-shadow-2xl transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          READY TO ELEVATE YOUR KENNEL?
        </h1>

        {}
        <div className={cn("relative group transition-all duration-1000 delay-200 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          {}
          <div className="absolute -inset-1 bg-primary/30 rounded-xl blur-xl opacity-0 group-hover:opacity-100 transition duration-700" />
          
          <Button asChild size="lg" className="relative bg-primary text-primary-foreground hover:bg-primary/90 border-none h-auto py-5 px-10 rounded-xl text-lg md:text-xl font-bold tracking-widest shadow-[0_0_30px_rgba(212,175,55,0.2)] hover:shadow-[0_0_50px_rgba(212,175,55,0.4)] transition-all duration-500">
            <Link to="#" className="flex items-center gap-3">
              APPLY FOR CONCIERGE SERVICES
              <ArrowRight className="size-6" />
            </Link>
          </Button>
        </div>

        {}
        <div className={cn("mt-10 flex flex-col md:flex-row items-center gap-2 md:gap-8 text-muted-foreground text-xs md:text-sm uppercase font-sans font-medium tracking-[0.2em] transition-all duration-1000 delay-300 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <span className="flex items-center gap-2">
            <CircleCheck className="size-4 text-primary" />
            Custom Website Digital Strategy
          </span>
          <span className="hidden md:inline-block opacity-30 text-primary">|</span>
          <span className="flex items-center gap-2">Application system</span>
        </div>
      </div>
    </section>;
}